export default __webpack_public_path__ + "static/media/selected.88ef5013.svg";